export const category = [
  { zh: { name: '首页' }, url: '/', sub: [] },
  // {
  //     zh: { name: '产品及服务' },
  //     url: '#',
  //     sub: [
  //         { zh: { name: '物联模组' }, url: '#' },
  //         { zh: { name: '物联软件' }, url: '#' },
  //         { zh: { name: '智能产品' }, url: '#' },
  //     ],
  // },
  // {
  //     zh: { name: 'IoT平台接入' },
  //     url: '#',
  //     sub: [
  //         { zh: { name: '小米IoT' }, url: '#' },
  //         { zh: { name: '天猫精灵IoT' }, url: '#' },
  //         { zh: { name: '华为IoT' }, url: '#' },
  //     ],
  // },
  // { zh: { name: '智能产品方案' }, url: '/smart', sub: [] },
  // {
  //     zh: { name: '行业解决方案' },
  //     url: '#',
  //     sub: [
  //         { zh: { name: '智慧家庭' }, url: '/help/63/document' },
  //         { zh: { name: '智慧酒店' }, url: '/help/64/document' },
  //         { zh: { name: '智慧办公' }, url: '/help/65/document' },
  //         { zh: { name: '智慧公寓' }, url: '/help/66/document' },
  //     ],
  // },
  // {
  //     zh: { name: '乐式动态' },
  //     url: '#',
  //     sub: [
  //         { zh: { name: '关于乐式' }, url: '/help/58/document' },
  //         { zh: { name: '乐式新闻' }, url: '/help/57/document' },
  //         { zh: { name: '商务合作' }, url: '#' },
  //     ],
  // },
  //   {
  //     zh: { name: '帮助中心' },
  //     url: '#',
  //     sub: [
  //       { zh: { name: '文档中心' }, url: '/help/55/document' },
  //       { zh: { name: '教程说明' }, url: '/help/51/document' },
  //       { zh: { name: '我要反馈' }, url: '#' },
  //       { zh: { name: '常见问题' }, url: '/help/56/document' },
  //     ],
  //   },
  { zh: { name: 'SAAS' }, url: '/saas', sub: [] },
  { zh: { name: '关于乐式' }, url: '/about', sub: [] },
  // {
  //     zh: { name: '云服务' },
  //     url: '#',
  //     sub: [
  //         { zh: { name: '天猫精灵IoT接入' }, url: '/help/59/document' },
  //         { zh: { name: '小米IoT接入' }, url: '/help/60/document' },
  //         { zh: { name: '涂鸦智能接入' }, url: '/help/61/document' },
  //         { zh: { name: 'le+自建服务器' }, url: '/help/62/document' },
  //     ],
  // },
];

export const contact = '400-1588-162';

export const _isMobile = () =>
  navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);

export const _isWeChat = () => navigator.userAgent.toLowerCase().indexOf('micromessenger') != -1;
